import type { ReactNode } from "react";
import { Chevron, mkLink } from "../components/MkButton";
import { AppVisual, CallVisual, WhatsAppVisual } from "../components/visuals";

const CHANNELS: {
	id: string;
	name: string;
	line: string;
	href: string;
	link: string;
	visual: ReactNode;
}[] = [
	{
		id: "app",
		name: "In your app",
		line: "A drop-in SDK for iOS, Android and the web that fills the cart your app already has.",
		href: "/channels/in-app",
		link: "In-app assistant",
		visual: <AppVisual />,
	},
	{
		id: "whatsapp",
		name: "On WhatsApp",
		line: "Product cards, a basket and a checkout the shopper confirms, on your own number.",
		href: "/channels/whatsapp",
		link: "WhatsApp shopping",
		visual: <WhatsAppVisual />,
	},
	{
		id: "voice",
		name: "On the phone",
		line: "It takes orders by voice in Saudi and Gulf Arabic, English and 30+ languages, and reads the basket back.",
		href: "/channels/voice",
		link: "Voice ordering",
		visual: <CallVisual />,
	},
];

/** The three places one assistant works: same catalog, same basket, same rules. */
export function Channels() {
	return (
		<section aria-labelledby="channels-title" className="mk-section">
			<div className="mk-container">
				<div className="mk-reveal mx-auto max-w-3xl text-center">
					<h2 id="channels-title" className="mk-h2 scroll-mt-24">
						One assistant, wherever your shoppers are.
					</h2>
					<p className="mk-lead mt-5 text-(--mk-ink-2)">
						The same catalog, basket and rules in every channel. A
						shopper can start in one and finish in another.
					</p>
				</div>
				<ul className="mt-14 grid gap-4 sm:mt-20 lg:grid-cols-3">
					{CHANNELS.map((channel) => (
						<li
							key={channel.id}
							className="mk-rise flex flex-col overflow-hidden rounded-[28px] bg-(--mk-mist)"
						>
							<div className="px-7 pt-8 sm:px-8">
								<h3 className="mk-h3">{channel.name}</h3>
								<p className="mt-2 text-(--mk-ink-2) text-[16px] leading-relaxed">
									{channel.line}
								</p>
								<a
									href={channel.href}
									className={mkLink("mt-4 text-[15px]")}
								>
									{channel.link}
									<Chevron />
								</a>
							</div>
							<div className="mt-auto px-6 pt-10">
								{channel.visual}
							</div>
						</li>
					))}
				</ul>
			</div>
		</section>
	);
}
